// this file is @generated

// biome-ignore-all lint/suspicious/noEmptyInterface: backwards compat

export interface StripeConfigOut {}

export const StripeConfigOutSerializer = {
  _fromJsonObject(_object: any): StripeConfigOut {
    return {};
  },

  _toJsonObject(_self: StripeConfigOut): any {
    return {};
  },
};
